import { CFG_MIN_STEP_MS } from '../../protocol/constants.ts';
import type { JigStep } from '../../protocol/types.ts';

export interface ClickerSettings {
  button: number;
  /** Press-to-press interval; includes hold time. */
  intervalMs: number;
  holdMs: number;
  durationS: number;
}

export function validateClicker(settings: ClickerSettings): string[] {
  const errors: string[] = [];
  if (![1, 2, 4].includes(settings.button)) errors.push('Choose left, right or middle button.');
  if (!Number.isInteger(settings.intervalMs) || settings.intervalMs < 2 * CFG_MIN_STEP_MS || settings.intervalMs > 65535) {
    errors.push(`Interval must be a whole number from ${2 * CFG_MIN_STEP_MS} to 65535 ms.`);
  }
  if (!Number.isInteger(settings.holdMs) || settings.holdMs < CFG_MIN_STEP_MS ||
      settings.holdMs > settings.intervalMs - CFG_MIN_STEP_MS) {
    errors.push(`Hold must be at least ${CFG_MIN_STEP_MS} ms and leave at least ${CFG_MIN_STEP_MS} ms released between clicks.`);
  }
  if (!Number.isInteger(settings.durationS) || settings.durationS < 0 || settings.durationS > 65535) {
    errors.push('Duration must be a whole number from 0 to 65535 seconds; 0 runs until stopped.');
  }
  return errors;
}

/** Existing macro schema: a held-button report, then an explicit release. */
export function buildClicker(settings: ClickerSettings): JigStep[] {
  const errors = validateClicker(settings);
  if (errors.length) throw new RangeError(errors.join(' '));
  return [
    { dx: 0, dy: 0, wheel: 0, buttons: settings.button, delayMs: settings.holdMs },
    { dx: 0, dy: 0, wheel: 0, buttons: 0, delayMs: settings.intervalMs - settings.holdMs },
  ];
}
